import apiService from '../../../services/api-client';
import { 
  AdjustmentFilters, 
  AdjustmentResponse, 
  AdjustmentBulkRequest, 
  AdjustmentApiResponse,
  ContainerOriginChangeRequest,
  ContainerOriginChangeResponse
} from '../interfaces';

export const adjustmentsApi = {
  // Obtener artículos para ajuste (usar mismo endpoint que reclasificación)
  getArticlesForAdjustment: async (
    companyId: number, 
    filters: AdjustmentFilters = {}
  ): Promise<AdjustmentResponse> => {
    const params = new URLSearchParams();
    
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.code) params.append('code', filters.code);
    if (filters.description) params.append('description', filters.description);
    if (filters.location_id) params.append('location_id', filters.location_id.toString());
    if (filters.container_id) params.append('container_id', filters.container_id.toString());
    // El listado de ajustes usa el mismo origen que reclasificar
    const response = await apiService().get(
      `/company/${companyId}/products/classified/lightweight?${params.toString()}`
    );
    const data = response.data || {};
    const storages = data.lightweight_product_storages || [];
    const pagination = data.pagination || {};

    return {
      articles: storages,
      total_elements: pagination.total_elements || 0,
      total_pages: pagination.total_pages || 0,
      page: pagination.page || 1,
      size: pagination.size || storages.length,
    };
  },

  // Realizar ajustes masivos
  performAdjustments: async (
    companyId: number,
    request: AdjustmentBulkRequest
  ): Promise<AdjustmentApiResponse> => {
    const response = await apiService().post(
      `/company/${companyId}/adjustments`,
      request
    );
    return response.data;
  },

  // Cambiar contenedor de origen
  changeContainerOrigin: async (
    companyId: number,
    request: ContainerOriginChangeRequest
  ): Promise<ContainerOriginChangeResponse> => {
    const response = await apiService().post(
      `/company/${companyId}/adjustments/container-origin`,
      request
    );
    return response.data;
  },

  // Sin endpoints extra (motivos/proveedores) en esta versión
};
